const ICON = {
  PHONE: 'https://cdn.51ljb.cn/ljb_h5_card_service_phone.png',
  FACE: 'https://cdn.51ljb.cn/ljb_h5_card_service_face.png',
  DOC: 'https://cdn.51ljb.cn/ljb_h5_card_service_doc.png',
  SEND: 'https://cdn.51ljb.cn/ljb_h5_card_service_send.png',
  CASE: 'https://cdn.51ljb.cn/ljb_h5_card_service_case.png'
}

const SERVICE_PHONE = {
  icon: 'https://cdn.51ljb.cn/ljb_h5_card_service_phone.png',
  name: '电话咨询',
  text: '有效期内，可无限次在线发起电话法律咨询。'
}

const SERVICE_FACE = {
  icon: 'https://cdn.51ljb.cn/ljb_h5_card_service_face.png',
  name: '见面咨询',
  text: '有效期内，申请前往制定律所进行见面咨询，享受平台标价的七折优惠。'
}

const SERVICE_DOC = {
  icon: 'https://cdn.51ljb.cn/ljb_h5_card_service_doc.png',
  name: '文书审查',
  text: '有效期内，可在线发起与生活相关的法律文件律师审查（3份/年，不含公司事务）。'
}

const SERVICE_DOC_COM = {
  icon: 'https://cdn.51ljb.cn/ljb_h5_card_service_doc.png',
  name: '文书审查',
  text: '有效期内，可在线发起与生活相关的法律文件律师审查。'
}

const SERVICE_SEND = {
  icon: 'https://cdn.51ljb.cn/ljb_h5_card_service_send.png',
  name: '发律师函',
  text: '有效期内，发生生活相关纠纷的，申请律师出具具备法律效力的函件（3份/年，不含公司事务）。'
}
const SERVICE_CASE = {
  icon: 'https://cdn.51ljb.cn/ljb_h5_card_service_case.png',
  name: '代打官司',
  text: '等待期满后的一年内，发生标的额30万元以内的民事被诉案件，享受免费律师代理（1次/年）。'
}

const COM_SERVICE = [
  SERVICE_PHONE,
  SERVICE_DOC_COM
]

const CardConfig = {
  'MC19001': {
    service: [
      SERVICE_PHONE,
      SERVICE_FACE
    ]
  },
  'MC19002': {
    service: [
      SERVICE_PHONE,
      SERVICE_FACE,
      SERVICE_DOC,
      SERVICE_SEND,
      SERVICE_CASE
    ]
  },
  'MC15001': {
    service: COM_SERVICE
  },
  'MC15002': {
    service: COM_SERVICE
  },
  'MC15003': {
    service: COM_SERVICE
  },
  'MC15004': {
    service: COM_SERVICE
  },
  'MC20001': {
    service: COM_SERVICE,
    name: '守住财神',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「债权债务」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_cs.html'
    }
  },
  'MC20002': {
    service: COM_SERVICE,
    name: '医患无忧',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「医疗纠纷」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_yhwy.html'
    }
  },
  'MC20003': {
    service: COM_SERVICE,
    name: '职场达人',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「劳动人事」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_zcdr.html'
    }
  },
  'MC20004': {
    service: COM_SERVICE,
    name: '一脉相承',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「继承」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_ymxc.html'
    }
  },
  'MC20005': {
    service: COM_SERVICE,
    name: '好心分手',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「婚姻」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_hxfs.html'
    }
  },
  'MC20006': {
    service: COM_SERVICE,
    name: '买房装修',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「房产物业」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_mfzx.html'
    }
  },
  'MC20007': {
    service: COM_SERVICE,
    name: '出入平安',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「交通出行」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_crpa.html'
    }
  },
  'MC20008': {
    service: COM_SERVICE,
    name: '宝贝计划',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「其他」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_bbjh.html'
    }
  },
  'MC20009': {
    service: COM_SERVICE,
    name: '消费维权',
    desc: {
      list: [
        '1、会员权益：',
        '  ①为会员本人提供有效期内无限次「消费维权」方面电话法律咨询服务;',
        '  ②为会员本人提供全年1次文书/合同审查服务；',
        '  ③为会员本人提供全年律师见面咨询服务7折优惠；'
      ],
      url: 'https://app.51ljb.cn/app-h5/agreement/bw_xfwq.html'
    }
  }

}

const WhichCardConfig = (productCode) => {
  if (productCode) {
    if (
      productCode === 'MC19005' ||
      productCode === 'MC19004' ||
      productCode === 'MC19003'
    ) {
      productCode = 'MC19001'
    } else if (
      productCode === 'MC18004' ||
      productCode === 'MC18003' ||
      productCode === 'MC18002'
    ) {
      productCode = 'MC15001'
    }

    return CardConfig[productCode]
  }
}

export default {
  CardConfig,
  WhichCardConfig
}



// WEBPACK FOOTER //
// ./src/const/data.js